﻿import React from 'react';
import ReactDOM from 'react-dom';

import FilterContainer from '../../product-filter/components/FilterContainer';
import FilterCategory from '../../product-filter/components/FilterCategory';
import './projectorfilterapplicationlessprofessional.scss';

import SortList from '../../product-filter/sort-type/sort';

// Sorts
const newest = {
    label: i18njs["Resource.ProjectorFilterSortNewest"],
    value: 'newest',
    sort: (products) => {
        if (!Array.isArray(products)) {
            console.warn("Products should be an array. No sort has been applied");
            return products;
        }
        return [...products].sort((a, b) => b.EpochTimeSeconds - a.EpochTimeSeconds);
    }
}

const relevance = {
    label: i18njs["Resource.ProjectorFilterSortRelevance"],
    value: 'relevance',
    sort: (products) => {
        if (!Array.isArray(products)) {
            console.warn("Products should be an array");
            return products;
        }
        return [...products].sort((a, b) => b.ProductScore - a.ProductScore);

    }
}

const brightness = {
    label: i18njs["Resource.Brightness"],
    value: 'brightness',
    sort: (products) => {
        if (!Array.isArray(products)) {
            console.warn("Products should be an array");
            return products;
        }
        return [...products].sort((a, b) => b.BrightnessLumens - a.BrightnessLumens);

    }
}

const sortList = new SortList([newest, relevance, brightness]);
const htmlElement = document.getElementById("filteredPage");

ReactDOM.render(
    <FilterContainer apiUrl={htmlElement.dataset.apiurl} sortList={sortList} defaultSort={brightness}
        localisedStrings={{
            filter: i18njs["Resource.ProjectorFilterFilter"],
            sort: i18njs["Resource.ProjectorFilterSort"],
            items: i18njs["Resource.ItemsLCase"],
            NoProductsAvailable: i18njs["Resource.NoProductsAvailable"]
        }}
    >
        <FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingNativeResolution"]} dataPoint={"NativeResolutionDisplayName"} checkboxOrderBy={"NativeResolutionOrder"} orderByDirection={"desc"} type={"checkbox"} />
        <FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingBrightness"]} dataPoint={"BrightnessLumens"} type={"range"} step={100} />
        {/*<FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingLightSource"]} dataPoint={"LightSource"} type={"checkbox"} />*/}
        <FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingWeight"]} dataPoint={"WeightKg"} type={"range"} collapsed units={"kg"} />
        <FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingLensType"]} dataPoint={"LensTypeFeatures"} type={"checkbox"} collapsed isAnd />
        <FilterCategory heading={i18njs["Resource.AspectRatio"]} dataPoint={"NativeAspectRatio"} type={"checkbox"}/>
        <FilterCategory heading={i18njs["Resource.ThrowRatioMin"]} dataPoint={"ThrowRatioMin"} type={"range"} step={0.001} />
        <FilterCategory heading={i18njs["Resource.ThrowRatioMax"]} dataPoint={"ThrowRatioMax"} type={"range"} step={0.001} />
        {/*<FilterCategory heading={"Throw Ratio"} dataPoint={"MaxThrowDistanceCm"} type={"range"} collapsed />*/}
        {/*<FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingProjectionDistance"]} dataPoint={"MaxProjectionDistanceMeters"} type={"range"} collapsed units={"m"} />*/}
        <FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingConnectivity"]} dataPoint={"Connections"} type={"checkbox"} collapsed isAnd />
        <FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingInstallation"]} dataPoint={"InstallationFeatures"} type={"checkbox"} collapsed isAnd />
        <FilterCategory heading={i18njs["Resource.ProjectorFilterHeadingFeatures"]} dataPoint={"SpecFeatures"} type={"checkbox"} collapsed isAnd />
    </FilterContainer>,
    document.getElementById("filteredPage")
);